import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Mlt from './Mlt';
import PreEscalationMessages from '../settings/PreEscalationMsgReact';
import $ from 'jquery';
import SupportUnavailableResponse from './SupportUnavailableResponse';

class EntityMainTab extends Component {

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/multilingual/responses";
            var path1 = window.origin + "/platform/projectmgmt/multilingual/responses/";
            if (currentPath === path || currentPath === path1) {
                $("#mlt1-tab").addClass('active');
            } else if (currentPath.includes('/responses/pre-escalation-messages')) {
                $("#pre-escalation-tab").addClass('active');
            } else if (currentPath.includes('/responses/support-unavailable-response')) {
                $("#support-unavailable-tab").addClass('active');
            } $("#mlt1-tab,#pre-escalation-tab,#support-unavailable-tab")
                .on("click", function () {
                    $("#mlt1-tab,#pre-escalation-tab,#support-unavailable-tab")
                        .removeClass('active');

                    $(this).addClass('active')
                })
        })();
    }
    render() {
        return (

            <div id="tabPage" >
                <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    {/* Font Awesome Icons */}
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    {/* IonIcons */}
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    {/* Theme style */}
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="./assets/css/toggleButton.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />

                    <div className="container-fluid" style={{ marginLeft: '0px' }} >
                        {/* Nav tabs */}
                        <div className="tab-class">
                            <ul className="nav nav-tabs border-bottom navCluster" >
                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/multilingual/responses" style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="mlt1-tab">
                                        Multilingual Responses
                                    </li></Link>
                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/multilingual/responses/pre-escalation-messages" style={{ textDecoration: 'none' }}>
                                    {/* <div className="border-bottom"></div> */}
                                    <li className=" nav-link" id="pre-escalation-tab" style={{ marginRight: '15px' }}>
                                        Missed-Query Responses
                                    </li></Link>
                                <Link className="nav-item" data-toggle="tab"
                                    to="/projectmgmt/multilingual/responses/support-unavailable-response" style={{ textDecoration: 'none' }}>
                                    {/* <div className="border-bottom"></div> */}
                                    <li className=" nav-link" id="support-unavailable-tab" style={{ marginRight: '15px' }}>
                                        Support-Unavailable Responses
                                    </li></Link>

                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/multilingual/responses/support-unavailable-response" component={SupportUnavailableResponse}></Route>
                    <Route path="/projectmgmt/multilingual/responses/pre-escalation-messages" component={PreEscalationMessages}></Route>
                    <Route path="/projectmgmt/multilingual/responses" component={Mlt}></Route>
                </Switch>
            </div>

        );
    }
}
export default EntityMainTab;


// WEBPACK FOOTER //
// ./src/projectmgmt/MultiLingualData/BotResponsesMainTab.js